import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useEffect, useRef, useState } from 'react';
import { UnauthQueryOptions } from '@/api';
import { Image } from '@/components/client';
const IMAGES = {
  goldMedal: 'https://cdn.welfarehello.com/static/gold_medal.png',
  silverMedal: 'https://cdn.welfarehello.com/static/silver_medal.png',
  bronzeMedal: 'https://cdn.welfarehello.com/static/bronze_medal.png'
};
export const PrizeSection = () => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/home-donation-event-history/invitee-donation/top"]({
        query: {
          eventCode: "DECEMBER_EVENT",
          size: 10
        }
      }),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data
  } = useSuspenseQuery(t0);
  const [maxWidth, setMaxWidth] = useState(0);
  const containerRef = useRef(null);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (!containerRef.current) {
        return;
      }
      const measureElements = () => {
        const topThreeElements = containerRef.current?.querySelectorAll("[data-rank=\"1\"] .name-price-container, [data-rank=\"2\"] .name-price-container, [data-rank=\"3\"] .name-price-container");
        if (!topThreeElements || topThreeElements.length === 0) {
          return;
        }
        let maxElementWidth = 0;
        topThreeElements.forEach(element => {
          const width = element.scrollWidth;
          if (width > maxElementWidth) {
            maxElementWidth = width + 4;
          }
        });
        setMaxWidth(maxElementWidth);
      };
      measureElements();
      document.fonts.ready.then(measureElements);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== data) {
    t2 = [data];
    $[2] = data;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fontSize: "32px"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="mb-20 text-center font-800 leading-[120%] text-Gray-white" style={t3}>실시간 친구 기부 완료<br />TOP 10</h2>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex justify-between px-12 py-4 font-700 text-B-100 typo-body4"><p>실시간 순위</p><p>닉네임</p><p>친구 기부 횟수</p></div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== data || $[8] !== maxWidth) {
    t6 = data?.map((item, index) => {
      const rank = index + 1;
      const price = (() => {
        switch (rank) {
          case 1:
            {
              return 200000;
            }
          case 2:
            {
              return 100000;
            }
          case 3:
            {
              return 50000;
            }
          default:
            {
              return;
            }
        }
      })();
      return <RankingRow key={index} name={item.maskedNickname} rank={rank} count={item.donationCount} price={price} nicknameMinWidth={maxWidth} />;
    });
    $[7] = data;
    $[8] = maxWidth;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <div className="flex w-full flex-col" ref={containerRef}>{t4}<div className="flex flex-col gap-4">{t5}{t6}</div></div>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
interface RankingRowProps {
  /** 이름 */
  name: string;
  /** 순위 */
  rank: number;
  /** 친구 기부 횟수 */
  count?: number;
  /** 금액 */
  price?: number;
  /** 닉네임 최소 너비 */
  nicknameMinWidth: number;
}
const RankingRow = t0 => {
  const $ = _c(28);
  const {
    count,
    name,
    rank,
    price,
    nicknameMinWidth
  } = t0;
  let t1;
  bb0: switch (rank) {
    case 1:
      {
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <Image alt="goldMedal" fill={true} sizes="30px" src={IMAGES.goldMedal} />;
          $[0] = t2;
        } else {
          t2 = $[0];
        }
        t1 = t2;
        break bb0;
      }
    case 2:
      {
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <Image alt="silverMedal" fill={true} sizes="30px" src={IMAGES.silverMedal} />;
          $[1] = t2;
        } else {
          t2 = $[1];
        }
        t1 = t2;
        break bb0;
      }
    case 3:
      {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <Image alt="bronzeMedal" fill={true} sizes="30px" src={IMAGES.bronzeMedal} />;
          $[2] = t2;
        } else {
          t2 = $[2];
        }
        t1 = t2;
        break bb0;
      }
    default:
      {
        t1 = null;
      }
  }
  const medalImage = t1;
  const t2 = rank <= 3;
  let t3;
  if ($[3] !== t2) {
    t3 = cn("relative flex size-30 min-w-0 shrink-0 items-center justify-center gap-4", {
      "items-end": t2
    });
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== rank) {
    t4 = <span className="relative z-10 font-700 typo-caption1">{rank}</span>;
    $[5] = rank;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== medalImage || $[8] !== t3 || $[9] !== t4) {
    t5 = <div className={t3}>{t4}{medalImage}</div>;
    $[7] = medalImage;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = rank <= 3 && nicknameMinWidth > 0 ? `${nicknameMinWidth}px` : "auto";
  let t7;
  if ($[11] !== t6) {
    t7 = {
      width: t6
    };
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== name) {
    t8 = <p className="truncate font-600 text-Gray-white typo-caption1">{name}님</p>;
    $[13] = name;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== price) {
    t9 = price ? <p className="min-w-77 truncate rounded-b-pill rounded-e-pill bg-O-400 px-10 py-2 font-700 text-Y-50 typo-caption1">{price?.toLocaleString()}원</p> : null;
    $[15] = price;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t10 = <div className="name-price-container flex min-w-0 items-center justify-between gap-8" style={t7}>{t8}{t9}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = rank <= 2 ? "?" : `${count}명`;
  let t12;
  if ($[21] !== t11) {
    t12 = <p className="min-w-40 text-center font-700 typo-caption1">{t11}</p>;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== rank || $[24] !== t10 || $[25] !== t12 || $[26] !== t5) {
    t13 = <div className="flex items-center justify-between rounded-pill bg-[#5cb8ff] px-30 py-12 text-Gray-white" data-rank={rank}>{t5}{t10}{t12}</div>;
    $[23] = rank;
    $[24] = t10;
    $[25] = t12;
    $[26] = t5;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context?.contents;
}